module.exports = __webpack_public_path__ + "img/bu-line2.827d798c.svg";